declare global {
  interface Window {
    Swiper: any;
  }
}

export function initEkHighlightProduct(root: ParentNode = document): void {
  const sections = root.querySelectorAll<HTMLElement>('[data-ek-highlight-product]');
  if (!sections.length) return;

  if (typeof window.Swiper !== 'function') {
    setTimeout(() => initEkHighlightProduct(root), 50);
    return;
  }

  for (const section of Array.from(sections)) {
    if (section.dataset.ekHighlightProductInit === '1') continue;
    section.dataset.ekHighlightProductInit = '1';

    const card = section.querySelector('.product-card');
    const imageSwiperEl = card?.querySelector<HTMLElement>('.product-image-swiper');
    const swatchSwiperEl = card?.querySelector<HTMLElement>('.highlight-swatch-swiper');
    const productLink = card?.querySelector<HTMLAnchorElement>('.product-link');
    const ctaLink = section.querySelector<HTMLAnchorElement>('[data-cta-link]');
    if (!imageSwiperEl || !swatchSwiperEl) continue;

    const imageSwiper = new window.Swiper(imageSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
    });

    const swatchSwiper = new window.Swiper(swatchSwiperEl, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swatchSlides = swatchSwiperEl.querySelectorAll<HTMLElement>('.swatch-slide');

    const contentPanels = section.querySelectorAll<HTMLElement>('[data-highlight-content]');

    const updateActiveSlide = (slide: HTMLElement) => {
      const url = slide.dataset.url || '';
      const color = slide.dataset.color || '';

      if (productLink) productLink.setAttribute('href', url);
      if (ctaLink) ctaLink.setAttribute('href', url);

      for (const panel of Array.from(contentPanels)) {
        panel.classList.toggle('hidden', panel.dataset.highlightContent !== color);
      }

      swatchSlides.forEach((swatch) => {
        swatch.classList.toggle('active-swatch', swatch.dataset.color === color);
      });
    };

    swatchSlides.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const color = swatch.dataset.color;
        if (!color) return;

        const idx = Array.from(imageSwiper.slides).findIndex(
          (slide) => (slide as HTMLElement).dataset.color === color
        );

        if (idx === -1) return;

        imageSwiper.slideTo(idx);
      });
    });

    imageSwiper.on('slideChange', () => {
      const active = imageSwiper.slides[imageSwiper.activeIndex] as HTMLElement;
      if (!active) return;

      updateActiveSlide(active);
    });

    if (imageSwiper.slides.length > 0) {
      const firstSlide = imageSwiper.slides[0] as HTMLElement;
      updateActiveSlide(firstSlide);

      const firstColor = firstSlide.dataset.color;
      swatchSlides.forEach((slide, index) => {
        if (slide.dataset.color !== firstColor) return;

        try {
          swatchSwiper.slideTo(index, 0);
        } catch {}
      });
    }
  }
}
